import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { VesselDAO } from '../../../../../../../core/services/dao/vesselDAO';
import { ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-request-edit',
  templateUrl: './request-edit.component.html',
  styleUrls: ['./request-edit.component.scss'],
})
export class RequestEditComponent implements OnInit, OnDestroy {
  @Input() onTab: string;

  @Output() hideRequestEditForm = new EventEmitter<any>();

  edits: string;
  placeholder: string;
  numberOfBlurs = 0;
  staticPlaceholderText =
    'Example: Need to update the description section to include new features for my boat.' +
    '\n\nAdd the following features. 1. Wake-board Tower and Wake-board 2. Refrigerator';

  constructor(
    private vesselDao: VesselDAO,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
  ) {}

  ngOnInit() {
    this.edits = this.staticPlaceholderText;
  }

  requestEdit() {
    this.vesselDao
      .requestEdits(
        this.route.snapshot.params.id,
        `On Tab: ${this.onTab.toUpperCase()} - ` + this.edits,
      )
      .subscribe(() => {
        this.hideRequestEditForm.emit();
        this.openSnackbar('Edit request sent successfully');
      });
  }

  openSnackbar(message: string) {
    this.snackBar.open(message, null, {
      duration: 5000,
      verticalPosition: 'top',
    });
  }

  /**
   onFocus, onBlur, and isDisabled only exist as a multiline placeholder hack for the textarea.
   I don't like it either.
   */
  public onFocus(): void {
    this.numberOfBlurs++;
    if (this.numberOfBlurs < 2) {
      this.edits = '';
    }
    if (!this.edits) {
      this.placeholder = '';
    }
  }

  public onBlur(): void {
    if (!this.edits) {
      this.placeholder = this.staticPlaceholderText;
    }
  }

  public isDisabled(): boolean {
    return !(this.numberOfBlurs > 0 && !!this.edits);
  }

  ngOnDestroy(): void {}
}
